import imgError from "../static/images/toast/error.png";
// import imgSuccess from '../static/images/toast/success.png';
import imgLoad from "../static/images/toast/load.gif";
const Toast = {
    // DURATION_SHORT: 1500,
    // DURATION_LONG: 5000,
    // DURATION_ALWAYS: -1,
    // DELAY_SHORT: 300,
    // DELAY_LONG: 1000,
    // POSITION_BOTTOM: "bottom",
    // POSITION_CENTER: "cneter",
    // POSITION_LITTLEBOTTOM: "littlebottom",

    _default: {
        text: "undefined",
        duration: 2000,
        delay: 0,
        position: "bottom",
    },
    // _wait: [],
    // _boxOnPag: null,
    _getClientHeight: () => {
        return document.documentElement.clientHeight;
    },
    _getClientWidth: () => {
        return document.documentElement.clientWidth;
    },
    _createMaskBox: () => {
        let dom = document.createElement("div");
        dom.className = "toast-mask";
        dom.style.cssText = `position:fixed;top:0;left:0;right:0;bottom:0;z-index:999;`;
        document.getElementById("root").appendChild(dom);
    },
    _creatInfoBox: function (text) {
        const height = this._getClientHeight();
        const width = this._getClientWidth();
        let dom = document.createElement("div");
        dom.className = "toast";
        if (text) dom.innerText = text;
        else dom.innerText = this._default.text;
        dom.style.cssText = `display:inline-block;border-radius:5px;line-height:20px;transition:all 0.5s linear;opacity:0;text-align:center;background:rgba(0,0,0,0.5);font-size:12px;color:#fff;position:absolute;min-width:80px;max-width:200px;padding:6px 10px;top:${
            height / 3 + 20
        }px;`;
        document.getElementById("root").appendChild(dom);
        dom.style.left = (width - dom.clientWidth) / 2 + "px";
        this._boxAnimation(dom, height, true);
    },
    _creatErrorBox: function (text) {
        const height = this._getClientHeight();
        const width = this._getClientWidth();
        let dom = document.createElement("div");
        dom.className = "toast";
        let imgDom = new Image();
        imgDom.src = imgError;
        let textDom = document.createElement("div");
        if (text) textDom.innerText = text;
        else textDom.innerText = this._default.text;
        dom.style.cssText = `display:inline-block;border-radius:5px;line-height:20px;text-align:center;transition:all 0.5s linear;opacity:0;background:rgba(0,0,0,0.5);font-size:12px;color:#fff;position:absolute;width:120px;height:100px;top:${
            height / 3
        }px;`;
        imgDom.style.cssText = `position:absolute;width:50px;height:50px;left:35px;top:15px;`;
        textDom.style.cssText = `position:absolute;left:0;right:0;bottom:6px;height:20px;font-size:12px;color:#fff`;
        dom.appendChild(imgDom);
        dom.appendChild(textDom);
        document.getElementById("root").appendChild(dom);
        dom.style.left = (width - dom.clientWidth) / 2 + "px";
        this._boxAnimation(dom, height);
    },
    _creatLoadBox: function (text) {
        const height = this._getClientHeight();
        const width = this._getClientWidth();
        let imgDom = new Image();
        imgDom.src = imgLoad;
        let dom = document.createElement("div");
        dom.className = "toast";
        let textDom = document.createElement("div");
        if (text) textDom.innerText = text;
        else textDom.innerText = "loading";
        dom.style.cssText = `display:inline-block;border-radius:5px;line-height:20px;text-align:center;transition:all 0.5s linear;opacity:0;background:rgba(0,0,0,0.5);font-size:12px;color:#fff;position:absolute;width:120px;height:100px;top:${
            height / 3
        }px;`;
        imgDom.style.cssText = `position:absolute;width:80px;height:80px;left:20px;top:0`;
        textDom.style.cssText = `position:absolute;left:0;right:0;bottom:6px;height:20px;font-size:12px;color:#fff`;
        dom.appendChild(imgDom);
        dom.appendChild(textDom);
        document.getElementById("root").appendChild(dom);
        dom.style.left = (width - dom.clientWidth) / 2 + "px";
        this._boxAnimation(dom, height);
    },
    _boxAnimation: function (element, height, isInfo) {
        // if(this.duration) const duration = this.duration;
        // else const duration = this._default.duration;
        const duration = this.duration ? this.duration : this._default.duration;
        element.style.opacity = "1";
        element.style.top = `${(height * 1) / 3}px`;
        isInfo &&
            setTimeout(() => {
                this.clear(element);
            }, duration);
    },
    clear: function () {
        const ele = document.getElementsByClassName("toast")[0];
        const eleMask = document.getElementsByClassName("toast-mask")[0];
        ele.style.opacity = "0";
        setTimeout(() => {
            document.getElementById("root").removeChild(ele);
            if (eleMask) {
                document.getElementById("root").removeChild(eleMask);
            }
        }, 1000);
    },
    info: function (param) {
        const { text, duration } = param ? param : {};
        this.duration = duration;
        this._createMaskBox();
        this._creatInfoBox(text);
    },
    error: function (param) {
        const { text, duration } = param ? param : {};
        this.duration = duration;
        this._creatErrorBox(text);
    },
    load: function (param) {
        const { text, duration } = param ? param : {};
        this.duration = duration;
        this._creatLoadBox(text);
    },
};

export default Toast;



// WEBPACK FOOTER //
// ./src/utils/toast.js